/* lua.js generated code 0.3.0 */

var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
var SettingPanelRecommandTip = xClass("SettingPanelRecommandTip", BasePanel, function () {
    return cc.CSLoader.createNode("cocos/setting_panel_tips2.csb")
})
SettingPanelRecommandTip.show = function (modelLevel) {
    let panel = SettingPanelRecommandTip.create(modelLevel)
    panel.popup(true)
}

SettingPanelRecommandTip.prototype.init = function (modelLevel) {
    var self = this
    BasePanel.prototype.init.call(self)
    let str1 = ""
    let str2 = ""
    if (modelLevel > 1){
        str1 = getText("performance.recommend.low.1")
        str2 = getText("performance.recommend.low.2")
    }else{
        str1 = getText("performance.recommend.high.1")
        str2 = getText("performance.recommend.high.2")
    }
    self.getChildByName("label_1").getVirtualRenderer().setHorizontalAlignment(cc.TEXT_ALIGNMENT_LEFT)
    self.getChildByName("label_2").getVirtualRenderer().setHorizontalAlignment(cc.TEXT_ALIGNMENT_LEFT)
    self.getChildByName("label_2").x = -25
    self.getChildByName("label_1").setString(str1)
    self.getChildByName("label_2").setString(str2)

    self.smoothDCSession = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`
    DCAssist.dc4SettingSmooth("quality_smooth_note_show", {
        session:self.smoothDCSession
    }) 
}

SettingPanelRecommandTip.prototype.onClickEmpty = function() {
    let self = this
    self.onKeyBackClicked()
}

SettingPanelRecommandTip.prototype.popup = function () {
    var self = this
    // body
    var targetScale = self.getScale()
    self.setScale(0)
    PopoutManager.getInstance().addWithBgFadeIn(self, true, false)
    var s = self.getContentSize()
    var pos = self.getAnchorPoint()
    var vSize = cc.Director.getInstance().getVisibleSize()
    var targetPos = cc.p((vSize.width - s.width) * 0.5 + s.width * pos.x, (vSize.height + s.height) * 0.5 + s.height * pos.y)
    self.setPosition(cc.p(vSize.width / 2, vSize.height / 2 - 80))
    var midPoint = cc.pMul(cc.pSub(targetPos, cc.p(self.getPosition())), 1.05)
    self.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(0.25, 1.05 * targetScale), cc.MoveBy.create(0.25, midPoint))), cc.EaseSineIn.create(cc.Spawn.create(cc.ScaleTo.create(0.25, targetScale), cc.MoveTo.create(0.25, targetPos)))))
    return self
}
SettingPanelRecommandTip.prototype.fitResolution = function () {
    var self = this
    // body
}

module.exports = SettingPanelRecommandTip
